import useAuth from '@/context/auth/useAuth';
import useTransactions from '@/app/(profile)/transactions/services/useTransactions';
import useRequest from '@/helpers/request/requestHook';
import dict from '@/dictionaries/fa.json';
import CoinGiftModal from '@/components/CoinGiftModal';
import useIsAndroid from '@/helpers/useIsAndroid';
import NavbarContainer from '@/components/navbar/NavbarContainer';
import useLayoutConfig from '@/context/layoutConfig/useLayoutConfig';
import { cn } from '@/helpers/cn';
import { useEffect, useState } from 'react';
import GlobalAudioPlayerContainer from '@/components/containers/GlobalAudioPlayerContainer';
import HobeFloatingButton from '@/app/hobe/components/HobeFloatingButton';
import { usePathname } from 'next/navigation';
import useIsRestricted from '@/helpers/useIsRestricted';

export default function AppWrapper({ children }) {
    const [showNavbar, setShowNavbar] = useState(false);
    const { hasNavbar, hasHobe } = useLayoutConfig();
    const { showCoinGiftModal, setShowCoinGiftModal, userIsLoggedIn, babyMode } = useAuth({
        initializeApp: true
    });
    const isAndroid = useIsAndroid();
    useTransactions({ fetchWalletBalance: true });
    const pathname = usePathname();
    useIsRestricted(babyMode && pathname === '/', '/babies');
    useRequest();

    useEffect(() => {
        console.log(
            `%c Dorsa Version: ${process.env.NEXT_PUBLIC_APP_VERSION} `,
            'background: #45b0f6; color: white; font-weight: bold; padding: 5px 10px; border-radius: 8px;'
        );
        setTimeout(() => {
            setShowNavbar(true);
        }, 0);
    }, []);

    return (
        <>
            {children}
            {hasNavbar && (
                <footer className={cn('transition', showNavbar ? 'opacity-100' : 'opacity-0')}>
                    <NavbarContainer />
                </footer>
            )}
            {hasHobe && userIsLoggedIn && !isAndroid && <HobeFloatingButton />}
            <CoinGiftModal
                title={dict.dailyGiftModal.title}
                description={dict.dailyGiftModal.description}
                buttonLabel={dict.dailyGiftModal.ok}
                isVisible={showCoinGiftModal && !isAndroid}
                onClose={() => setShowCoinGiftModal(false)}
                onButtonClick={() => setShowCoinGiftModal(false)}
                image="/images/daily-coin.png"
            />
            <GlobalAudioPlayerContainer
                className={!hasNavbar ? 'global-audio-player-container-without-navbar' : ''}
            />
        </>
    );
}
